import { types, Instance } from 'mobx-state-tree';

// appsInstallerEvents :: appInstallStatus, appInstallComplete, appInstallCanceled

export interface IInstallStatus extends Instance<typeof InstallStatus> {}

const StatInfo = types.model('StateInfo', {
    processed: types.optional(types.number, 0),
    total: types.optional(types.number, 0),
    rate: types.number,
});

const InstallStatus = types.model('InstallStatus', {
    productID: types.identifier,
    status: types.string,
    patcher_type: types.optional(types.string, ''),
    progress: types.optional(types.number, 0),
    download_stat: types.maybe(StatInfo),
    install_stat: types.maybe(StatInfo),
    streaming: types.optional(types.string, ''), // SSI: smart streaming install (value = activated | executable )
    timeRemaining: types.maybe(
        types.model({
            hours: types.string,
            minutes: types.string,
            seconds: types.string,
        })
    ),
});

export default InstallStatus;
